export default {"src":"/_next/static/media/kcs.4193ee4e.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};